<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>卡密管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    
    <el-card class="content">
      <!-- 醒目公告 -->
      <!-- <el-alert type="error" effect="dark" show-icon :closable="false" style="margin-top: 5px; margin-bottom: 5px;">
        <template slot="title">
          <span style="font-size: 15px; font-weight: bold;">
            📢 系统维护通知：将于 2026年8月21 日凌晨 00:00 - 01:00 进行服务器升级维护，届时不要新建卡密，部分服务可能受影响，请提前做好准备！
          </span>
        </template>
      </el-alert> -->
      <div class="navbtn">
        <el-card class="button-content">
          <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refreshCurrentPage" :loading="state"></el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="newCreateCard" :loading="state">新建卡密</el-button>
          <el-button type="primary" size="small" icon="el-icon-download" @click="exports" :loading="state">导出</el-button>
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="imports" :loading="state">导入</el-button>
          <el-badge :value="totalStrip" class="item">
            <el-button type="primary" size="small" @click="batchOperation" class="operation" :loading="state" icon="el-icon-copy-document">批量操作</el-button>
          </el-badge>
          <!-- <el-button type="warning" size="small" @click="clearNotUsed" :loading="state">一键删除未使用卡密</el-button> -->
          <el-button class="merge-btn" size="small" @click="multiMerge" :loading="state" icon="el-icon-connection">多开合并</el-button>
          <el-button type="danger" size="small" @click="clearExpire" :loading="state" icon="el-icon-delete">删除过期卡密</el-button>
          <el-button type="danger" size="small" @click="clearBtn" ref="clearRef" v-show="isClear" :loading="state">清除所有选中</el-button>
        </el-card>
      </div>

      <el-form :inline="true" :model="queryInfo" class="demo-form-inline" ref="searchFormRef" size="small">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable :style="inputWidth?{width:'100%'}:{width:'300px'}" @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡类 " prop="cardName">
          <el-select v-model="queryInfo.cardName" placeholder="全部卡类" clearable :style="inputWidth?{width:'100%'}:{width:'300px'}" @change="changeInput()">
            <el-option v-for="item in allCardType" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态 " prop="states">
          <el-select v-model="queryInfo.states" placeholder="所有状态" clearable :style="inputWidth?{width:'100%'}:{width:'240px'}" @change="changeInput()">
            <!-- <el-option v-for="item in allState" :key="item" :label="item" :value="item"></el-option> -->
            <el-option label="未使用" value="未使用"></el-option>
            <el-option label="正常" value="正常"></el-option>
            <el-option label="过期" value="过期"></el-option>
            <el-option label="冻结" value="冻结"></el-option>
            <!-- <el-option label="已使用" value="正常"></el-option> -->
            <el-option label="已激活" value="已激活"></el-option>
            <el-option label="封禁" value="封禁"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="制卡人" prop="producer" class="producer">
          <el-select v-model="queryInfo.producer" placeholder="全部" clearable :style="inputWidth?{width:'100%'}:{width:'416px'}" @change="changeInput()">
            <el-option v-for="item in producer" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡密 " prop="cardPassword">
          <el-input v-model="queryInfo.cardPassword"  clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'400px'}"></el-input>
        </el-form-item>

        <el-form-item label="备注 " prop="remarks">
          <el-input v-model="queryInfo.remarks" style="width:100%" clearable placeholder="支持模糊查询" :style="inputWidth?{width:'100%'}:{width:'300px'}"></el-input>
        </el-form-item>
        <!-- <div style="clear:both">
          <div class="label-btn"> -->
        <!-- <el-form-item label="最近使用 " class="lately" prop="lately" style="marginTop:1px"> -->
        <el-form-item label="激活时间 " class="lately" prop="active" style="marginTop:1px">
          <div class="lately-div">
            <el-date-picker ref="datepickerRef" v-model="queryInfo.active" type="daterange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :style="inputWidth?{width:'200px'}:{width:'100%'}"></el-date-picker>
          </div>
        </el-form-item>
        <!-- <el-form-item label="查看代理链 " prop="link">
          <el-checkbox v-model="queryInfo.link"></el-checkbox>
        </el-form-item> -->
        
        <el-form-item >
          <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
          <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
        </el-form-item>
          
        <!-- </div>
        </div> -->
        
      </el-form>
      

      <el-table :data="cardTableData" border style="width: 100%" stripe ref="table" v-loading="loading" @selection-change="handleSelectionChange" row-key="_id">
        <el-table-column type="selection" :reserve-selection="true" width="40" ></el-table-column>
        <el-table-column prop="cardPassword" label="卡密" width="390"></el-table-column>
        <el-table-column prop="softName" label="所属软件" width="200"></el-table-column>
        <el-table-column prop="cardName" label="卡类" width="150"></el-table-column>
        <el-table-column prop="online" label="在线" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.online === true" style="color: #237804" ><i class="iconfont icon-yuandianxiao" style="margin-right:0px;margin-left:0px;vertical-align:-2px"></i>在线</span>
            <span v-if="scope.row.online === false" style="color: #d80821"><i class="iconfont icon-yuandianxiao" style="margin-right:0px;margin-left:0px;vertical-align:-2px"></i>离线</span>
          </template>
        </el-table-column>

        <el-table-column prop="state" label="状态" width="70">
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.freeze === true" style="color: #d80821">冻结</span> -->
            <span v-if="scope.row.freeze === true" style="color: #d80821">封禁</span>
            <span v-if="scope.row.state === '正常' && scope.row.freeze === false && scope.row.freezeTime === false" style="color: #237804">{{scope.row.state}}</span>
            <span v-if="scope.row.state === '未使用' && scope.row.freeze === false && scope.row.freezeTime === false" style="color: #606266">{{scope.row.state}}</span>
            <span v-if="scope.row.state === '过期' && scope.row.freeze === false && scope.row.freezeTime === false" style="color: #ad6800">{{scope.row.state}}</span>
            <span v-if="scope.row.freezeTime === true" style="color: #d80821">冻结</span>
            <!-- <span v-if="scope.row.state === '冻结'" style="color: #d80821">{{scope.row.state}}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="upperLimit" label="多开" width="50"></el-table-column>
        <el-table-column prop="crowding" label="顶号" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.crowding === false" style="color: #d80821">否</span>
            <span v-if="scope.row.crowding === true" style="color: #237804">是</span>
          </template>
        </el-table-column>
        
        <el-table-column prop="unbundling" label="解绑" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.unbundling === false" style="color: #ad6800">未开启</span>
            <span v-if="scope.row.unbundling === true" style="color: #237804">是</span>
          </template>
        </el-table-column>

        <el-table-column label="当前解绑次数/允许解绑次数" width="140">
          <template #default="{row}">
            {{ row.currentUnbindNum }}/{{ row.unbindNumUpperLimit }}
          </template>
        </el-table-column>

        <el-table-column prop="createDate" label="生成时间" width="170"></el-table-column>
        <el-table-column prop="expireDate" label="到期时间" width="170"></el-table-column>
        <el-table-column prop="latelyDate" label="最近使用" width="170"></el-table-column>
        <el-table-column prop="freezeDate" label="冻结时间" width="170">
          <template slot-scope="scope">
            <span style="color: #d80821">{{scope.row.freezeDate}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="activeDate" label="激活时间" width="170"></el-table-column>
        <el-table-column prop="agent" label="代理人" width="170"></el-table-column>
        <el-table-column prop="remarks" label="备注" width="170"></el-table-column>
        <el-table-column prop="configure" label="配置" width="170"></el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text">编辑</el-button>
            
            <el-dropdown>
              <span class="el-dropdown-link" style="font-size:14px">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="cardPasswordLog(scope.row)">日志</el-dropdown-item>
                <el-dropdown-item @click.native="kickLine(scope.row)">踢下线</el-dropdown-item>
                <el-dropdown-item @click.native="multiTransform(scope.row)">多开转换</el-dropdown-item>
                <el-dropdown-item v-if="!scope.row.freezeTime" @click.native="freezeCardTime(scope.row)">冻结时间</el-dropdown-item>
                <el-dropdown-item v-else @click.native="unfreezeCardTime(scope.row)">解冻时间</el-dropdown-item>
                
                <!-- <el-dropdown-item v-if="!scope.row.freeze" @click.native="freezeCard(scope.row)">冻结卡密</el-dropdown-item> -->
                <el-dropdown-item v-if="!scope.row.freeze" @click.native="freezeCard(scope.row)">封禁卡密</el-dropdown-item>
                <!-- <el-dropdown-item v-else @click.native="unfreezeCard(scope.row)">解冻卡密</el-dropdown-item> -->
                <el-dropdown-item v-else @click.native="unfreezeCard(scope.row)">解封卡密</el-dropdown-item>

                <el-dropdown-item :style="{color:'red'}" @click.native="delCard(scope.row)">删除卡密</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 新建卡密dialog -->
    <el-dialog title="新建卡密" :close-on-click-modal="false" :visible.sync="createCardDiaLog" :width="newCreateCardPassword" class="newcreatecardpassword">
      <!-- 新建卡密的Form表单 -->
      <el-form :model="createCardForm" :rules="rules" ref="createCardFormRef" label-width="100px" class="demo-ruleFormCreate" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="createCardForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡类" prop="cardName">
          <el-select v-model="createCardForm.cardName" placeholder="请选择卡类" clearable @change="changeInput()">
            <el-option v-for="item in allCardType" :key="item._id" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="生成数量" prop="generateNum">
          <el-input-number :precision="0" v-model="createCardForm.generateNum" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="createCardForm.remarks" :autosize="{ minRows: 1, maxRows: 4}" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>

        <el-form-item label="卡密配置" prop="configure">
          <el-input type="textarea" v-model="createCardForm.configure" placeholder="长度不超过512个字符"></el-input>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="22px">
          <div class="custom">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">是否自定义 卡密前缀、顶号登录、多<br/>开上限 参数，它们默认是继承至所属<br/>软件</div>
              <label for="customid" style="margin-left:0px">自定义<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="customid" style="display: block" v-model="createCardForm.custom" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="卡密前缀" prop="prefix" v-show="createCardForm.custom">
          <el-input v-model="createCardForm.prefix" placeholder="不超过5个字符"></el-input>
        </el-form-item>

        <el-form-item label="" prop="singleDevice" label-width="22px" v-show="createCardForm.custom">
          <div class="custom singlecreate">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">单设备多开:只绑定一个设备号，适用于pc软件<br/>多设备多开:绑定多个设备号，适用于手机软件</div>
              <label for="" >多开模式<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-radio-group v-model="createCardForm.singleDevice" @change="getright">
              <el-radio  class="lf" label="true" border>单设备多开</el-radio>
              <el-radio  class="lr" label="false" border>多设备多开</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>

        <el-form-item label="多开上限" prop="upperLimit" v-show="createCardForm.custom">
          <el-input-number :precision="0" v-model="createCardForm.upperLimit" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>

        <el-form-item label="允许解绑次数" prop="unbindNumUpperLimit" v-show="createCardForm.custom">
          <el-input-number :precision="0" v-model="createCardForm.unbindNumUpperLimit" controls-position="right" :min="0" :max="9999999"></el-input-number>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="8px" v-show="createCardForm.custom">
          <div class="custom">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">在超过多开上限时，顶号登录：后登<br/>录的会把先登录的挤下线；不顶号登<br/>录：后登录的直接返回登录失败。</div>
              <label for="crowdingid" style="margin-left:0px">顶号登录<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="crowdingid" style="display: block" v-model="createCardForm.crowding" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createCard" :loading="state">创 建</el-button>
      </span>
    </el-dialog>

    <!-- 删除卡密的Dialog -->
    <el-dialog title="确定要删除此卡密？" :close-on-click-modal="false" :visible.sync="delDialog" :width="diaLogWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定要删除此卡密？<br></span>
      </div>
      <div class="tip-title-danger">* 删除代理未使用卡密将返还积分</div>
      <div style="margin-left:30px;margin-bottom:20px"><span>{{thisCard.cardPassword}}</span></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="delDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量操作的Dialog -->
    <el-dialog title="批量操作卡密:" :close-on-click-modal="false" :visible.sync="batchOperationDialogVisible" :width="diaLogWidth" @close="closeBatchOperation">
      <el-form :model="batchOperationForm" :rules="batchOperationRules" ref="batchOperationFormRef" label-width="100px">
        <div>
          <el-tooltip class="itemlist" effect="dark" placement="top">
            <span slot="content">注意: 一行一条卡密, 以回车分割</span>
            <label for="cardlengthid" >卡密列表<i class="iconfont icon-wenhaoxiao"></i></label>
          </el-tooltip>
          <el-form-item label="" prop="info" label-width="91px">
            <el-input type="textarea" v-model="batchOperationForm.info" :autosize="{ minRows: 20,maxRows: 20}"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer batch">
        <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定要删除以上卡密？(* 删除代理未使用卡密将返还积分)" @confirm="batchDel()">
          <el-button slot="reference" type="danger" size="small" :loading="state">批量删除</el-button>
        </el-popconfirm>
        <!-- <el-button slot="reference" type="danger" size="small" @click="batchDel">批量删除</el-button> -->
        <el-button type="primary" size="small" @click="batchUnfreeze" :loading="state">批量解封</el-button>
        <el-button type="primary" size="small" @click="batchFreeze" :loading="state" class="frezee">批量封禁</el-button>

        

        <el-button type="warning" size="small" @click="batchunbind" :loading="state" class="frezee">批量解绑</el-button>

        <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定要对以上卡密续费？(* 对未使用的卡密续费无效)" @confirm="batchRenew()">
          <el-button slot="reference" type="primary" size="small" :loading="state">批量续费</el-button>
        </el-popconfirm>
        <el-button type="primary" size="small" @click="batchUnfreezeTime" :loading="state">批量冻结</el-button>
        <el-button type="primary" size="small" @click="batchFreezeTime" :loading="state" class="frezee">批量解冻</el-button>
        <!-- <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定要对以上卡密加时？(* 对未使用的卡密加时无效)" @confirm="batchExtraTime()">
          <el-button slot="reference" type="primary" size="small" :loading="state">批量加时</el-button>
        </el-popconfirm> -->

        <el-popover placement="bottom" width="170" trigger="manual" v-model="visible">
          <div class="popover-content" style="margin-bottom:10px">
            <p>对未使用的卡密加时无效!!!</p>
            <div>
              <span style="display: inline-block; width: 20px; text-align: right; margin-right: 4px;">加</span><el-input-number :precision="0" size="mini" v-model="days" :min="0" :max="1000" style="margin-bottom: 5px;"></el-input-number><span>天</span>
              <span style="display: inline-block; width: 20px; text-align: right; margin-right: 4px;">加</span><el-input-number :precision="0" size="mini" v-model="hours" :min="0" :max="1000" style="margin-bottom: 5px;"></el-input-number><span>时</span>
              <span style="display: inline-block; width: 20px; text-align: right; margin-right: 4px;">加</span><el-input-number :precision="0" size="mini" v-model="minutes" :min="0" :max="100000" style="margin-bottom: 5px;"></el-input-number><span>分</span>
            </div>
            
          </div>
          <div class="operate-btns" style="margin-left:67px;">
            <el-button size="mini" type="text" @click="visible = false">取消</el-button>
            <el-button size="mini" type="primary" @click="batchExtraTime" :loading="state">确定</el-button>
          </div>
          <el-button slot="reference" @click="visible = !visible" type="primary" size="small" :loading="state">批量加时</el-button>
        </el-popover>
      </span>
    </el-dialog>

    <!-- 编辑卡密对话框editDiaLog -->
    <el-dialog :title="titleCard" :close-on-click-modal="false" :visible.sync="editDiaLogVisible" :width="editDialogWidth" class="edit">
      <el-form ref="editFromRef" :model="editFrom" label-width="80px" :rules="editFromRules" class="edit-form" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="editFrom.softName" :disabled="true">
            <el-option :label="editFrom.softName" :value="editFrom.softName" ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注 " prop="remarks">
          <el-input type="textarea" v-model="editFrom.remarks" placeholder="长度不超过128个字符" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
        </el-form-item>

        <el-form-item label="卡密配置 " prop="configure">
          <el-input type="textarea" v-model="editFrom.configure" placeholder="长度不超过512个字符"></el-input>
        </el-form-item>
        <el-row>
          <el-form-item label="" prop="configure" label-width="22px">
            <div class="datetime">
              <el-tooltip class="datetime-item" effect="dark" placement="top">
                <div slot="content">注意：未激活状态下修改到期时间还<br/>是会在用户激活卡密时覆盖掉。</div>
                <label for="customid" >到期时间<i class="iconfont icon-wenhaoxiao"></i></label>
              </el-tooltip>
              <el-col :span="8">
                <el-date-picker v-model="editFrom.expireDate" type="datetime" placeholder="选择日期时间" :style="inputWidth?{width:'180%'}:{width:'250px'}"></el-date-picker>
              </el-col>
            </div>
          </el-form-item>
        </el-row>
        <el-form-item label="" prop="configure" label-width="22px">
          <div class="custom">
            <label for="customid" class="islabel">是否冻结</label>
            <el-switch id="customid" style="display: block" v-model="editFrom.freeze" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="" prop="configure" label-width="22px">
          <div class="custom edit-custom">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">是否自定义 卡密前缀、顶号登录、多<br/>开上限 参数，它们默认是继承至所属<br/>软件</div>
              <label for="customids" >自定义<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="customids" style="display: block" v-model="editFrom.custom" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>



        <el-form-item label="" prop="singleDevice" label-width="22px" v-show="editFrom.custom">
          <div class="custom single">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">单设备多开:只绑定一个设备号，适用于pc软件<br/>多设备多开:绑定多个设备号，适用于手机软件</div>
              <label for="" >多开模式<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-radio class="lf" v-model="editFrom.singleDevice" label="true"  border>单设备多开</el-radio>
            <el-radio class="lr" v-model="editFrom.singleDevice" label="false" border>多设备多开</el-radio>
          </div>
        </el-form-item>



        <el-form-item label="多开上限" prop="upperLimit" v-show="editFrom.custom">
          <el-input-number :precision="0" v-model="editFrom.upperLimit" controls-position="right" :min="1" :max="100"></el-input-number>
        </el-form-item>

        <el-form-item label="允许解绑次数" prop="unbindNumUpperLimit" label-width="100px" v-show="editFrom.custom" class="unbindnum">
          <el-input-number :precision="0" v-model="editFrom.unbindNumUpperLimit" controls-position="right" :min="0" :max="9999999"></el-input-number>
        </el-form-item>
        <el-form-item label="当前解绑次数" prop="currentUnbindNum" label-width="100px" v-show="editFrom.custom" class="unbindnum">
          <el-input-number :precision="0" v-model="editFrom.currentUnbindNum" controls-position="right" :min="0" :max="9999999"></el-input-number>
        </el-form-item>
        <el-form-item label="" prop="configure" label-width="8px" v-show="editFrom.custom">
          <div class="custom crowding">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">在超过多开上限时，顶号登录：后登<br/>录的会把先登录的挤下线；不顶号登<br/>录：后登录的直接返回登录失败。</div>
              <label for="crowdingid" >顶号登录<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-switch id="crowdingid" style="display: block" v-model="editFrom.crowding" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
          </div>
        </el-form-item>

        <el-form-item label="绑定设备号" prop="inputValue" label-width="100px" class="deviceid">
          <el-tag :key="tag" v-for="tag in editFrom.device_id" closable :disable-transitions="false" @close="handleClose(tag)">
            {{tag}}
          </el-tag>
          <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
            @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
          </el-input>
          
          <el-button v-else class="button-new-tag" size="small" @click="showInput" >+ 增 加</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="clearDevice" :loading="state">清空设备号</el-button>
        <el-button type="primary" size="small" @click="keepAlive" :loading="state">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 复制并关闭Dialog -->
    <el-dialog title="确定要删除此卡密？" :close-on-click-modal="false" :visible.sync="copyDialog" :width="copyWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-chenggong"></use>
          </svg>成功生成 {{many}} 张卡密
        </span>
      </div>
      <div ><span>{{thisCard.cardPassword}}</span></div>
      <el-form ref="copyFromRef" :model="copyFrom"  :rules="copyFromRules" >
        <el-form-item label="" prop="info" >
          <el-input type="textarea" v-model="copyFrom.cardResult" :autosize="{ minRows: 10,maxRows: 100}"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary"  size="small" :loading="state" v-clipboard:copy="copyFrom.cardResult" v-clipboard:success="onCopy">复制&关闭</el-button>
      </span>
    </el-dialog>

    <!-- 卡密日志Dialog -->
    <el-dialog :title="cardTitle" :close-on-click-modal="false" :visible.sync="cardPassworddialog" :width="cardDialogWidth">
      <div class="card-log">
        <el-card>
          <div class="card-header-flex">
            <div class="left-actions">
              <el-button size="small" type="primary" icon="el-icon-refresh" circle @click="cardRefresh" :loading="state" class="cardrefresh"></el-button>
              <el-badge :value="totalOnline" class="item">
                <el-popover placement="top-start" :width="popoverWidth" trigger="hover">
                    <div style="margin-bottom:10px;margin-left:10px">
                      序号 : <el-tag size="small">设备号</el-tag> : <el-tag  size="small" >token</el-tag>  : <el-tag size="small" type="success" effect="dark">心跳time</el-tag>
                    </div>
                    <div class="popover-scroll-container">
                      <div v-for="(item, index) in online" :key="item.token" style="margin-bottom:10px;margin-left:10px">
                        {{index+1}} : <el-tag size="small">{{item.split(":")[0]}}</el-tag> : <el-tag  size="small" >{{item.split(":")[1]}}</el-tag> : <el-tag class="time" size="small" type="success" effect="dark">{{timestampToTime(parseInt(item.split(":")[2])).substring(timestampToTime(parseInt(item.split(":")[2])).length - 8)}}</el-tag> 
                      </div>
                    </div>
                  
                  <el-button slot="reference" size="small" :loading="state">当前在线</el-button>
                  
                </el-popover>
              </el-badge>
            </div>
            <el-select v-model="selectedLogDate" placeholder="请选择日志日期" size="small" style="width: 160px; margin-right: 10px;" @change="handleDateChange">
              <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-card>
      </div>
      <el-table :data="cardLogData" border style="width: 100%" stripe>
        <el-table-column prop="action" label="动作" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.action === '登录'" style="color: #237804">登录</span>
            <span v-if="scope.row.action === '退出登录'" style="color: #0050b3">退出登录</span>
            <span v-if="scope.row.action === '解绑'" style="color: #ad6800">解绑</span>
            <span v-if="scope.row.action === '冻结'" style="color: #db0d0d">冻结</span>
            <span v-if="scope.row.action === '充值'" style="color: #db0d0d">充值</span>
            <span v-if="scope.row.action === '时间转移'" style="color: #db0d0d">时间转移</span>
            <span v-if="scope.row.action === '邀请充值'" style="color: #db0d0d">邀请充值</span>
            <span v-if="scope.row.action === '赠送'" style="color: #d48806">赠送</span>
            <span v-if="scope.row.action === '多开转换'" style="color: #08979c">多开转换</span>
          </template>
        </el-table-column>
        <el-table-column prop="sign" label="记录" >
          
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover" popper-class="my-popover">
              <code>
                <div v-if="Array.isArray(scope.row.sign)">
                  <span class="code-span" v-for="item in scope.row.sign" :key="item" style="margin-left:20px;margin-right:20px">{{item}}</span>
                </div>
                <div v-if="Object.prototype.toString.call(scope.row.sign) === '[object Object]'">
                  <span class="code-span">{</span>
                  <span class="code-span" v-for="(item,index) in scope.row.sign" :key="index" style="margin-left:20px;margin-right:20px">{{index}}: {{item}}</span>
                  <span class="code-span">}</span>
                </div>
                <div v-if="typeof(scope.row.sign)=='string'">
                  <span class="code-span" style="margin-left:20px;margin-right:20px">{{scope.row.sign}}</span>
                </div>
              </code>
              <div class="text-record" slot="reference" v-if="scope.row.sign">{{ scope.row.sign | capitalize }}</div>
            </el-popover>
          </template>
        
        </el-table-column>
        <el-table-column prop="ip" label="ip"  width="200">

          <template slot-scope="scope">
            <el-popover placement="top-start" width="200" trigger="hover"  popper-class="my-popover" @hide="closepopo" @show="showpopo(scope.row.ip)">
              <!-- <span class="code-span" v-for="(item,index) in ip" :key="index" style="margin-left:20px">{{index}}: {{item}},</span> -->
              <code>{{ip}}</code>
              <span style="color: #1890ff" slot="reference">{{ scope.row.ip }}</span>
            </el-popover>
          </template>

        </el-table-column>
        <el-table-column prop="createDate" label="时间" width="170"></el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="onlineHandleSizeChange"
        @current-change="onlineHandleCurrentChange"
        :current-page="onlineQueryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="onlineQueryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="onlineTotal"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="cardPassworddialog = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 批量导入 -->
    <el-dialog title="批量导入卡密:" :close-on-click-modal="false" :visible.sync="importDialog" :width="importWidth">
      
      <div>
        <el-form ref="file" label-width="120px">
          <el-form-item label="模板下载：">
            <el-link type="primary" :underline="false" @click="module">七C云卡密导入模板.csv</el-link>
          </el-form-item>
          <el-form-item label="CSV文件导入：">
            <el-upload class="upload-demo" ref="upload"
              drag
              accept=".csv"
              action=""
              :multiple="false"
              :limit="1"
              :auto-upload="false"
              :on-change="handleChange">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传csv文件</div>
              <div class="el-upload__tip" slot="tip" style="color:red">1.模板第一行不能删除<br>2.csv编码改成utf-8<br>3.文件末尾不要有空行</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="importCsv" :loading="state">导 入</el-button>
      </span>
    </el-dialog>
    <!-- 一键删除未使用卡密 -->
    <el-dialog title="确定要删除所有未使用卡密？" :visible.sync="notUsedialog" :width="newCreateCardPassword">
      <span>确定要删除所有未使用卡密？<span style="color:red">(* 删除代理未使用卡密将返还积分)</span></span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="notUsedialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="delNotUseCard">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除未过期卡密 -->
    <el-dialog title="确定要删除所有过期卡密？" :visible.sync="clearExpireDialog" :width="newCreateCardPassword">
      <span style="color:red">确定要删除*所有*过期卡密？删除后无法找回</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="clearExpireDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmClearExpire">绝不后悔(删除)</el-button>
      </span>
    </el-dialog>
    <!-- 多开转换弹窗 -->
    <el-dialog title="多开转换" :visible.sync="multiTransformDialogVisible" width="500px">
      <el-form :model="form" label-width="100px" v-if="currentRow">
        <el-form-item label="卡密：">
          <span>{{ currentRow.cardPassword }}</span>
        </el-form-item>
        <el-form-item label="多开上限：">
          <!-- Element UI 计数器组件 -->
          <el-input-number 
            size="mini"
            v-model="form.upperLimit" 
            :min="1" 
            :max="100" 
            @change="handleUpperLimitChange">
          </el-input-number>
        </el-form-item>
        <!-- 新增：显示剩余时间（小时数/天数） -->
        <el-form-item label="剩余时间：">
          <span style="color: #E6A23C; font-weight: bold;">{{ computedRemainingText }}</span>
        </el-form-item>
        <el-form-item label="转换后到期：">
          <span style="color: #F56C6C; font-weight: bold;">{{ computedExpireDate }}</span>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="multiTransformDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmTransform">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 多开合并 -->
    <el-dialog title="多开合并" :close-on-click-modal="false" :visible.sync="multiMergeDialogVisible" :width="diaLogWidth" @closed="resetForm"> 
      <!-- 红色提示文字 -->
      <div class="tip-title-danger">
        * 主卡多开数必须大于每个副卡多开数
      </div>
      <!-- 将主卡和副卡放入同一个 el-form 中，统一绑定 rules 和 ref -->
      <el-form :model="mergeForm" :rules="mergeRules" ref="mergeFormRef" label-width="100px" size="small">
        <!-- 1. 主卡区域 -->
        <div class="main-card-section">
          <div class="section-title">主卡信息</div>
          <el-form-item label="主卡卡密：" prop="mainCard">
            <el-input v-model="mergeForm.mainCard" placeholder="请输入主卡卡密" style="width: 100%;" clearable></el-input>
          </el-form-item>
        </div>
        <!-- 2. 副卡多开列表区域 -->
        <div class="sub-card-section">
          <div class="section-title">副卡列表</div>
          <!-- 必须添加 prop="subCardList"，校验规则才能生效 -->
          <el-form-item label="副卡卡密：" prop="subCardList">
            <el-input 
              type="textarea" 
              v-model="mergeForm.subCardList" 
              :rows="12"
              placeholder="请输入副卡卡密，每行一个（最多20行）"
              style="width: 100%;"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <!-- 弹窗底部操作 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="multiMergeDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmMerge">确定合并</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "../assets/fonts/iconfont.js";
import axios from 'axios'
export default {
  data(){
    let checkPrefix = (rule,value,cb) => {
      const regPrefix = /^[\d\w]+$/
      if(regPrefix.test(value) || value.length === 0){
        return cb()
      }
      cb(new Error('不能超过5个字符! 只能是字母、数字的组合!'))
    }
    let textarea = (rule, value, cb) => {
      let newValue = value.split('\n')
      const regPrefix = /^[\d\w]+$/gm
      if(regPrefix.test(value) && newValue.length <= 100){
        return cb()
      }
      cb(new Error('不能超过100条! 只能是字母、数字的组合!'))
    }
    // 1. 定义副卡校验逻辑
    const validateSubCardList = (rule, value, callback) => {
      if (!value || !value.trim()) {
        return callback(new Error('请输入副卡卡密'));
      }
      // 按换行符分割，过滤掉纯空行
      const lines = value.split('\n').filter(item => item.trim().length > 0);
      // 校验行数不得超过 20 行
      if (lines.length > 20) {
        return callback(new Error(`副卡最多只能输入 20 行，当前已输入 ${lines.length} 行`));
      }
      // 校验每一行的字符长度（10 到 45 个字符之间）
      for (let i = 0; i < lines.length; i++) {
        const len = lines[i].trim().length;
        if (len < 10 || len > 45) {
          return callback(new Error(`第 ${i + 1} 行副卡卡密长度须在 10~45 个字符之间（当前 ${len} 字）`));
        }
      }
      // 校验通过
      callback();
    };
    return{
      cardTableData: [],
      total:0,
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
        softName: "",
        cardName: "",
        generateNum: 1,
        remarks: "",
        configure: "",
        custom: false,
        prefix: "",
        upperLimit: "",
        crowding: false,
        states:"",
        producer:"",
        cardPassword:"",
        remarks:"",
        // lately:"",
        active:"",
        // link: "false"
      },
      loading: true,
      state: false,
      stateOver:false,
      createCardDiaLog:false,
      createCardForm:{
        softName: "",
        cardName: "",
        generateNum: 1,
        remarks: "",
        configure: "",
        custom: false,
        prefix: "",
        upperLimit: "",
        unbindNumUpperLimit: 9999999,
        crowding: false,
        email: this.$store.state.account,
        states:"",
        producer:"",
        cardPassword:"",
        remarks:"",
        singleDevice: "false"
      },
      rules:{
        softName:[
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        cardName:[
          { required: true, message: "请选择卡类!", trigger: ["blur", "change"] },
        ],
        remarks:[
          { min: 0,max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ],
        configure:[
          { min: 0,max: 512,message: "不能超过512个字符!",trigger: ["blur", "change"]},
        ],
        prefix:[
          { min: 0,max: 5,message: "不能超过5个字符",trigger: ["blur", "change"]},
          { validator: checkPrefix, trigger:'blur'}
        ]
      },
      email:this.$store.state.account,
      //此人的所有软件名
      allSoftName:[],
      allCardType:[],
      diaLogWidth:'500px',
      //删除卡密的dialog
      thisCard:"",
      delDialog:false,

      //批量操作的dialog
      batchOperationDialogVisible:false,
      totalStrip:"",
      cardTableArr:[],
      //批量操作卡密列表表单
      batchOperationForm:{
        info:"",
      },
      batchOperationRules:{
        info:[
          { required: true, message: "批量操作最多同时处理100张卡密!", trigger: ["blur", "change"] },
          { validator:textarea,trigger:'blur'}
        ]
      },

      isClear:false,
      inputWidth:false,
      allState: ['未使用','正常','已过期','已冻结','已使用'],
      producer: [],

      //'编辑卡密对话框
      editDiaLogVisible:false,
      editFrom:{},
      titleCard:"",
      editFromRules:{
        dateTime:'',
        remarks:[
          { min: 0,max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ],
        configure:[
          { min: 0,max: 512,message: "不能超过512个字符!",trigger: ["blur", "change"]},
        ],
      },
      inputVisible: false,
      inputValue: '',
      editDialogWidth:'500px',
      newCreateCardPassword:'500px',
      copyWidth:'600px',
      copyDialog:false,
      cardResult:[],
      copyFromRef:{},
      copyFromRules:{},
      copyFrom:{},
      many:0,
      deleteVisible:"",
      visible: false,
      days:0,
      hours:0,
      minutes:0,

      cardPassworddialog: false,
      cardTitle:"",
      cardDialogWidth:'1000px',
      popoverWidth:'560',
      cardLogData:[],
      ip: '',
      totalOnline: '',
      online: [],
      onlineQueryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        // last:"",
      },
      onlineTotal: 0,
      onlineIndex: "",
      importDialog: false,
      importWidth: "600px",
      file:{},
      notUsedialog: false,
      clearExpireDialog:false,

      lastId: null,
      firstId: null,
      selectedLogDate:"",
      dateOptions:[],

      multiTransformDialogVisible: false,
      currentRow: null,
      baseTotalMs: 0,            // 基础总毫秒数（用时间戳计算更精准）
      form: {
        upperLimit: 1
      },
      computedExpireDate: '',    // 界面显示的格式化日期
      rawComputedExpireTimestamp: 0, // 提交用的计算后时间戳
      computedRemainingText: '',    // 实时计算的剩余时间文本（包含小时）

      multiMergeDialogVisible: false,
      mergeForm: {
        mainCard: '', // 主卡卡密
        subCardList: '' // 副卡列表数据模拟
      },
      // 主卡表单校验规则
      mergeRules: {
        mainCard: [
          { required: true, message: '请输入主卡卡密', trigger: 'blur' },
          { min: 10, max: 45, message: '主卡卡密长度需在 10 到 45 个字符之间', trigger: 'blur' }
        ],
        // 绑定自定义副卡校验规则
        subCardList: [
          { required: true, validator: validateSubCardList, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed:{
    allTotal(){
      return this.batchOperationForm.info.split('\n').length
    }
  },
  watch:{
    batchOperationDialogVisible(val,oldVal){
      if(val === false){
        this.visible = false
        this.days = 0
        this.hours = 0
        this.minutes = 0
      }
    },
  },
  
  created(){
    this.getCardPassword()
    this.$nextTick(()=>{
      if (document.body.clientWidth < 768){
        this.diaLogWidth = '100%'
        this.inputWidth = true
        this.editDialogWidth = '100%'
        this.copyWidth = '100%'
        this.cardDialogWidth = '100%'
        this.popoverWidth = '100%'
        this.importWidth = '100%'
        this.newCreateCardPassword = '100%'
      }
    })
    this.getCardTypeSoftName()
    this.getProducer()
    this.initDateOptions();
  },
  methods:{
    query(){
      //this.queryInfo.lately = ""
      this.getCardPassword(1)
    },
    getright(val){
      // console.log("当前选中" + val);
      // this.createCardForm.singleDevice = val
      // console.log(this.createCardForm);
    },
    //刷新按钮
    refresh(){
      this.getCardPassword()
    },
    async getCardTypeSoftName(){
      this.stateOver = true
      const result = await this.$http.post("cardGetSoft");
      this.stateOver = false
      console.log("卡类的",result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
      //this.allCardType = result.data.data.resolve
      this.allCardType = result.data.data.resolve.map(element => {
        return element.cardName
      })
    },
    async getProducer(){
      this.stateOver = true
      const result = await this.$http.post("getProducer");
      this.stateOver = false
      console.log("制作者",result);
      // this.producer = result.data.data.map(element => {
      //   return element.agentEmail
      // })
      //this.producer = [...new Set(this.producer)]; //利用了Set结构不能接收重复数据的特点
      this.producer = result.data.data
      // console.log("this.producer:",this.producer);
    },
    
    /*
    async getCardPassword(index){
      this.state = true
      if(index){
        this.queryInfo.pagenum = 1
      }
      
      let queryInfo = JSON.stringify(this.queryInfo)
      queryInfo = JSON.parse(queryInfo)
      if (queryInfo.producer) {
        queryInfo.producer = this.queryInfo.producer.split('-')[0]
      }
      console.log("queryInfo:",queryInfo);
      // const result = await this.$http.post("getCardPassword", this.queryInfo);
      const result = await this.$http.post("getCardPassword", queryInfo);
      // console.log('获取卡密result-->',result.data);
      // if(result.data.meta.status !== 200){
      //   this.$notify.error({title: '错误', message:result.data.meta.msg});
      // }
      this.state = false
      if(!result.data.data.total){
        this.total = 0
        this.cardTableData = []
        this.loading = false
        return
      }
      this.total = result.data.data.total
      //this.cardTableData = result.data.data.data
      this.cardTableData = result.data.data.data.map(element =>{
        if(element.createDate){
          element.createDate = this.timestampToTime(parseInt(element.createDate))
        }
        if(element.expireDate){
          element.expireDate = this.timestampToTime(parseInt(element.expireDate))
        }
        if(element.latelyDate){
          element.latelyDate = this.timestampToTime(parseInt(element.latelyDate))
        }
        if(element.activeDate){
          element.activeDate = this.timestampToTime(parseInt(element.activeDate))
        }
        if(element.freezeDate){
          element.freezeDate = this.timestampToTime(parseInt(element.freezeDate))
        }
        //console.log(element.agent);
        // if(this.producer.indexOf(element.producer) === -1){//搜到了
        //   this.producer.push(element.producer)
        // }
        return element
      })
      this.loading = false
    },
    // 3. 新增：同页码刷新方法（可单独调用）
    refreshCurrentPage() {
      this.pageDirection = "refresh";
      this.getCardPassword();
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val;
      this.pageDirection = "resize";
      this.getCardPassword();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      if (val === this.queryInfo.pagenum) {
        this.refreshCurrentPage();
        return;
      }
      //console.log(`当前页: ${val}`);
      this.pageDirection = val > this.queryInfo.pagenum ? "forward" : "backward";
      this.queryInfo.pagenum = val
      this.getCardPassword()
    },
    */
    // 同步修复getCardPassword，确保pagesize传递正确
    // 确保数据加载后，正确更新 firstId（当前页最大 _id）和 lastId（当前页最小 _id）
    async getCardPassword(index, isJump, jumpDirection) {
      this.state = true
      this.loading = true
      if (index) {
        this.queryInfo.pagenum = 1;
        this.lastId = null;
        this.firstId = null;
      }

      let queryInfo = JSON.stringify(this.queryInfo)
      queryInfo = JSON.parse(queryInfo)
      // queryInfo.pagesize = this.queryInfo.pagesize || 10;
      console.log(`当前第${this.queryInfo.pagenum}页，每页${this.queryInfo.pagesize}`);
      
      if (queryInfo.producer) {
        queryInfo.producer = this.queryInfo.producer.split('-')[0]
      }
      
      queryInfo.lastId = this.lastId;
      queryInfo.firstId = this.firstId;
      // console.log("刷新最终请求参数：", queryInfo);
      try {
        const result = await this.$http.post("getCardPassword", queryInfo);
        console.log("result=>",result);
        
        if (!result.data.data.total) {
          this.total = 0
          this.cardTableData = []
          this.state = false
          this.loading = false
          return
        }
        
        this.total = result.data.data.total
        const originalData = result.data.data.data || [];
        
        // 数据加载后，更新 firstId 和 lastId（降序排序下，数组第0项是最大 _id，最后一项是最小 _id）
        if (originalData.length > 0) {
          this.firstId = originalData[0]._id; // 当前页最大 _id
          this.lastId = originalData[originalData.length - 1]._id; // 当前页最小 _id
          console.log("更新游标：", { firstId: this.firstId, lastId: this.lastId });
        }

        this.cardTableData = originalData.map(element => {
          if (element.createDate) {
            element.createDate = this.timestampToTime(parseInt(element.createDate))
          }
          if (element.expireDate) {
            element.expireDate = this.timestampToTime(parseInt(element.expireDate))
          }
          if (element.latelyDate) {
            element.latelyDate = this.timestampToTime(parseInt(element.latelyDate))
          }
          if (element.activeDate) {
            element.activeDate = this.timestampToTime(parseInt(element.activeDate))
          }
          if (element.freezeDate) {
            element.freezeDate = this.timestampToTime(parseInt(element.freezeDate))
          }
          return element
        })
      } catch (error) {
        console.error("刷新数据失败：", error);
      }
      this.state = false
      this.loading = false
    },
    // 3. 新增：同页码刷新方法（可单独调用）
    refreshCurrentPage() {
      // if (!this.queryInfo.pagesize) {
      //   this.queryInfo.pagesize = 10;
      // }
      this.getCardPassword(false);
    },


    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val;
      this.queryInfo.pagenum = 1;
      this.firstId = null;
      this.lastId = null;
      this.getCardPassword();
    },
    // 监听 页码值 改变的事件（核心改造：支持双向跳页）
    handleCurrentChange(val) {
      console.log("页码值：",val);

      if (val === this.queryInfo.pagenum) {
        this.refreshCurrentPage();
        return;
      }
      // ===== 核心：判断是否是跳页（非相邻页码）=====
      const oldPage = this.queryInfo.pagenum; // 原页码
      console.log(`oldPage=${oldPage} val=${val}`);
      if(val == (this.queryInfo.pagenum + 1)){
        this.firstId = null;
        console.log("----前翻页");
      }else if(val == (this.queryInfo.pagenum - 1)){
        this.lastId = null;
        console.log("----后翻页");
      }else{
        this.firstId = null;
        this.lastId = null;
        console.log("--------");
      }

      // 更新当前页码
      this.queryInfo.pagenum = val
      this.getCardPassword()
    },
    handleSelectionChange(val) {
      this.cardTableArr = val
      this.totalStrip = this.cardTableArr.length
      console.log('cardTableArr',this.cardTableArr);
      this.isClear = true
      if(this.cardTableArr.length === 0){
        this.totalStrip = ""
        this.isClear = false
      }
    },
    //点击清除所有
    clearBtn(){
      this.cardTableArr = []
      this.$refs.table.clearSelection()
      this.batchOperationForm.info = ""
    },
    //一键删除过期卡密
    clearExpire(){
      this.clearExpireDialog = true;
    },
    async confirmClearExpire(){
      this.state = true
      const result = await this.$http.post("clearexpire");
      console.log('一键清理过期卡密result-->',result);
      this.state = false
      if(result.data.meta.status === 200){
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getCardPassword()
        this.clearExpireDialog = false
        return
      }else{
        this.$notify.error({title: '错误', message:result.data.meta.msg});
        this.getCardPassword()
        this.clearExpireDialog = false
        return
      }
    },
    //一键删除未使用卡密
    clearNotUsed(){
      this.notUsedialog = true;
    },
    //确定一键删除未使用卡密
    async delNotUseCard(){
      this.state = true
      const result = await this.$http.post("delNotUseCard");
      console.log('一键删除未使用卡密result-->',result);
      this.state = false
      if(result.data.meta.status === 200){
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getCardPassword()
        this.notUsedialog = false
        return
      }else{
        this.$notify.error({title: '错误', message:result.data.meta.msg});
        this.getCardPassword()
        this.notUsedialog = false
        return
      }
    },
    //关闭批量操作dialog
    // close(){
    //   console.log('关闭批量操作dialog');
    //   this.batchOperationForm.info = ""
    //   this.$refs.batchOperationFormRef.resetFields()
        // this.$refs.batchOperationFormRef.resetFields()
    // },
    // handleClose(done){
    //   done()
    //   console.log('关闭批量操作dialog');
    //   this.batchOperationForm.info = ""
    //   this.$refs.batchOperationFormRef.resetFields()
    // },
    closepopo() {
      this.batchOperationForm.info = ""
      // console.log("this.$refs.batchOperationFormRef=",this.$refs.batchOperationFormRef);
      // this.$refs.batchOperationFormRef.resetFields()
    },
    closeBatchOperation(){
      this.$refs.batchOperationFormRef.resetFields()
    },
    //批量操作的点击事件
    batchOperation(){
      this.batchOperationForm.info = ""
      this.batchOperationDialogVisible = true
      this.batchOperationForm.info = this.batchOperationForm.info.split('...')
      this.cardTableArr.forEach(element => {
        this.batchOperationForm.info.push(element.cardPassword)
      });
      this.batchOperationForm.info = this.batchOperationForm.info.toString()
      this.batchOperationForm.info = this.batchOperationForm.info.replace(/,/g,"\n").trim()
      console.log('info',this.batchOperationForm.info);
    },
    //点击新建卡密的点击事件
    async newCreateCard(){
      // this.stateOver = true
      // const result = await this.$http.post("cardGetSoft", {email:this.email});
      // this.stateOver = false
      // //console.log(result);
      // this.allSoftName = result.data.data.result.map(element => {
      //   return element.softName
      // })
      // this.allCardType = result.data.data.resolve.map(element => {
      //   return element.cardName
      // })
      if (document.body.clientWidth < 700){
        this.newCreateCardPassword = '100%'
      }
      this.createCardDiaLog = true
    },
    
    //创建卡密
    createCard(){
      this.$refs.createCardFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        // console.log("this.createCardForm.singleDevice====",this.createCardForm.singleDevice);
        // console.log("this.createCardForm",this.createCardForm);
        // if(this.createCardForm.singleDevice){
        //   console.log("赋值true");
        //   this.createCardForm.singleDevice = "true";
        //   console.log("this.createCardForm.singleDevice====",this.createCardForm.singleDevice);
        //   console.log("---->this.createCardForm",this.createCardForm);
        // }else{
        //   this.createCardForm.singleDevice = "false";
        // }

        console.log("this.createCardForm-=-=-=",this.createCardForm);
        //window.sessionStorage.getItem('email')
        // let email = window.sessionStorage.getItem('email')
        // if (email) {
        //   this.createCardForm.producer = email  
        // }else{
        //   let msg = "参数错误"
        //   this.$notify.error({title: '错误', msg});
        //   return
        // }

        const result = await this.$http.post('createCard',this.createCardForm)
        this.state = false
        this.createCardDiaLog =false
        
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误', message:result.data.meta.msg});
          return
        }
        this.getCardPassword(1)
        this.many = result.data.data.length
        this.copyFrom.cardResult = result.data.data.map(element =>{
          return element.cardPassword
        })
        this.copyFrom.cardResult = this.copyFrom.cardResult.join('\n')
        //this.cardResult = result.data.data.map
        console.log('this.cardResult',this.copyFrom.cardResult);
        //console.log('生成数量:',result.data.data.length);
        this.copyDialog = true
        this.$refs.createCardFormRef.resetFields()
      })
    },
    
    
    delCard(value){
      console.log(value);
      this.thisCard = value
      this.delDialog = true
    },
    //删除单个卡密
    async delDialogBtn(){
      this.stateOver = true
      const result = await this.$http.post("delCard", this.thisCard);
      this.stateOver = false
      console.log('result',result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
      this.delDialog = false
    },
    //冻结卡密(封禁)
    async freezeCard(value){
      console.log(value);
      const result = await this.$http.post("freezeCard", value);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
    },
    //解冻卡密(解封)
    async unfreezeCard(value){
      const result = await this.$http.post("unfreezeCard", value);
      console.log(result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
    },
    //冻结时间
    async freezeCardTime(value){
      console.log(value);
      const result = await this.$http.post("freezeCardTime", value);
      console.log("冻结result:",result);
      
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
    },
    //解冻时间
    async unfreezeCardTime(value){
      const result = await this.$http.post("unfreezeCardTime", value);
      console.log(result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.getCardPassword()
    },
    //批量删除
    batchDel(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        const result = await this.$http.post('delManyCard',this.batchOperationForm)
        // const result = await this.$http.post('delManyCard',this.cardTableArr)
        this.state = false
        console.log(result);
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
      this.getCardPassword(1)
    },
    //批量解冻(批量解封)
    batchUnfreeze(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        const result = await this.$http.post('unfreezeMany',this.batchOperationForm)
        //console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    //批量冻结(批量封禁)
    batchFreeze(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        const result = await this.$http.post('freezeMany',this.batchOperationForm)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    //批量冻结
    batchUnfreezeTime(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        const result = await this.$http.post('freezeManyTime',this.batchOperationForm)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    //批量解冻
    batchFreezeTime(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        const result = await this.$http.post('unfreezeManyTime',this.batchOperationForm)
        //console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    //批量解绑
    batchunbind(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        const result = await this.$http.post('unbindMany',this.batchOperationForm)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    //批量续费
    batchRenew(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        const result = await this.$http.post('Renew',this.batchOperationForm)
        // const result = await this.$http.post('Renew',this.cardTableArr)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    onCopy(){
      this.copyDialog = false
      // this.$refs.copyFromRules.resetFields()
      this.$message.success('卡密已复制到剪贴板!')
    },
    //批量加时
    batchExtraTime(){
      this.$refs.batchOperationFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        this.batchOperationForm.day = this.days
        this.batchOperationForm.hours = this.hours
        this.batchOperationForm.minutes = this.minutes
        const result = await this.$http.post('addtime',this.batchOperationForm)
        // const result = await this.$http.post('addtime', {card:this.cardTableArr, day: this.num4})
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.batchOperationForm.info = ""
        this.batchOperationDialogVisible = false
        this.totalStrip = ""
        this.$refs.batchOperationFormRef.resetFields()
        this.cardTableArr = []
        this.$refs.table.clearSelection()
        this.batchOperationForm.info = ""
        this.getCardPassword()
      })
    },
    reSet(){
      // this.queryInfo.lately = ""
      this.queryInfo.active = ""
      this.$refs.searchFormRef.resetFields()
      this.firstId = null
      this.lastId = null
      this.pageDirection = null
      this.pagenum = 1
      this.getCardPassword(1)
      
      // console.log("this.producer:",this.producer);
    },
    async exports(){
      //const result = await this.$http.post("download", {email:this.$store.state.account});
      const result = await this.$http.get(`download/?email=${this.$store.state.account}`,{
        responseType: 'blob',
      });
      let url = window.URL.createObjectURL(new Blob([result.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.$store.state.account+".csv");
      document.body.appendChild(link);
      console.log('result',result);
      link.click();
      console.log('result',result);
    },
    //编辑点击事件
    handleClick(row){
      // 深度克隆对象，避免直接修改原数据
      this.editFrom = JSON.parse(JSON.stringify(row))
      
      // 正确处理布尔值 → 字符串，不污染原数据
      if (this.editFrom.singleDevice === true) {
        this.editFrom.singleDevice = "true"
      } else {
        this.editFrom.singleDevice = "false"
      }

      this.titleCard = '编辑卡密: ' + row.cardPassword
      this.editDiaLogVisible = true
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = (date.getMonth() + 1 < 10 ? (date.getMonth() + 1) : date.getMonth() + 1);
      var day = date.getDate();
      var hours = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month < 10) { month = '0' + month }
      if (day < 10) { day = '0' + day }
      if (hours < 10) { hours = '0' + hours }
      if (minute < 10) { minute = '0' + minute }
      if (second < 10) { second = '0' + second }
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minute + ':' + second;
    },
    clearDevice(){
      this.editFrom.device_id = []
    },
    keepAlive(){
      this.$refs.editFromRef.validate(async (value) => {
        if(!value) return
        this.state = true
        for (let index = 0; index < this.editFrom.device_id.length; index++) {
          if (this.editFrom.device_id[index].length > 50) {
            this.$notify.error({title: '错误', message:"单个设备号长度不能超过50个字符"});
            this.state = false
            return
          }
        }
        const result = await this.$http.post('update',this.editFrom)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.editDiaLogVisible = false
        this.getCardPassword()
      })
    },
    //绑定设备输入框的事件
    handleClose(tag) {
      this.editFrom.device_id.splice(this.editFrom.device_id.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        // if (inputValue.length > 50) {
        //   this.$message.error('单个设备号长度不能超过 50 个字符！');
        //   return; 
        // }
        // if (this.editFrom.device_id.includes(inputValue)) {
        //   this.$message.warning('该设备号已存在');
        //   return;
        // }
        this.editFrom.device_id.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },

    initDateOptions() {
      const options = [];
      for (let i = 0; i < 7; i++) {
        const date = new Date();
        date.setDate(date.getDate() - i); // 依次往前推

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        // 存储格式：20240506 (后端查表用)
        const value = `${year}${month}${day}`;
        // 显示格式：2024-05-06 (用户看)
        const label = i === 0 ? `今天 (${year}-${month}-${day})` : `${year}-${month}-${day}`;
        
        options.push({ value, label });
      }
      this.dateOptions = options;
      this.selectedLogDate = options[0].value; // 默认选中第一项（今天）
    },
    // 切换日期时的逻辑
    handleDateChange(val) {
      console.log('切换到日期表：', val);
      // 这里触发你的查询方法
      this.cardRefresh(); 
    },

    // 修改你的刷新方法，带上日期参数
    cardRefresh() {
      this.state = true;
      // 请求后端接口时，带上 this.selectedLogDate
      const params = {
        date: this.selectedLogDate, // 传给后端的后缀
        // ... 其他参数
      };
      this.cardPasswordLog(this.onlineIndex);
    },
    async cardPasswordLog(index){
      console.log("index=",index);
      
      this.online = ""
      this.totalOnline = ""
      console.log('index',index);
      if(index){
        this.onlineIndex = index
      }
      this.cardTitle = '卡密日志: '+this.onlineIndex.cardPassword
      this.state = true
      const result = await this.$http.get('cardpasswordlog',{
        params: {
          index: this.onlineIndex,
          queryInfo: this.onlineQueryInfo,
          logDate: this.selectedLogDate
        },
      })
      console.log('卡密日志result-->',result);
      this.state = false
      if(result.data.data.resolve){
        if(result.data.data.resolve.length > 0){
          //this.cardLogData = result.data.data.resolve
          this.cardLogData = result.data.data.resolve.map(element => {
            if(element.createDate){
              element.createDate = this.timestampToTime(parseInt(element.createDate))
            }
            if(element.sign.indexOf('{') > -1){
              element.sign = JSON.parse(element.sign)
            }else if(element.sign.indexOf('[') > -1){
              element.sign = JSON.parse(element.sign)
            }
            return element
          })
          //this.onlineQueryInfo.last = this.cardLogData[this.cardLogData.length - 1]
          // console.log("最后一条数据this.onlineQueryInfo.last：",this.onlineQueryInfo.last);
        }else{
          this.cardLogData = []
        }
        if(result.data.data.resData){
          // this.online = JSON.parse(result.data.data.resData)
          this.online = result.data.data.resData
          console.log('this.online',this.online);
          this.totalOnline = this.online.length
        }else{
          this.totalOnline = ""
        }
        this.onlineTotal = result.data.data.total
      }else{
        this.cardLogData = []
        this.onlineTotal = 0
      }
      
      this.cardPassworddialog = true
    },

    async kickLine(val){
      this.state = true
      let result = await this.$http.post('kickdownline',val)
      this.state = false
      if(result.data.meta.status === 200){
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getCardPassword()  
      }
    },
    // 点击下拉菜单触发
    multiTransform(val) {
      console.log("多开转换val=", val);
      if(!val.expireDate){
        this.$notify.error({title: '错误',message: "未使用卡密不能多开转换"});
        return
      }
      if (val.freeze) {
        this.$notify.error({title: '错误',message: "封禁卡密不能多开转换"});
        return
      }
      if (val.freezeTime){
        this.$notify.error({title: '错误',message: "冻结时间卡密不能多开转换"});
        return
      }
      this.currentRow = val;
      this.form.upperLimit = val.upperLimit || 1;  
      // 兼容处理：将 "YYYY-MM-DD HH:mm:ss" 转换为 "YYYY/MM/DD HH:mm:ss" 以确保 new Date() 跨浏览器正常
      const expireStr = val.expireDate ? val.expireDate.replace(/-/g, '/') : '';
      const expireTime = new Date(expireStr).getTime();
      const now = new Date().getTime();
      if (expireTime <= now){
        this.$notify.error({title: '错误',message: "卡密过期不能多开转换"});
        return
      }
      const remainingMs = expireTime - now;
      const safeRemainingMs = remainingMs > 0 ? remainingMs : 0;
      // 1. 计算“总资源毫秒数” (例如: 剩余毫秒数 * 当前多开上限)
      const currentUpperLimit = val.upperLimit || 1;
      this.baseTotalMs = safeRemainingMs * currentUpperLimit;
      // 2. 初始化显示当前到期时间
      this.computedExpireDate = val.expireDate;
      this.rawComputedExpireTimestamp = expireTime;
      console.log("computedExpireDate=",this.computedExpireDate);
      console.log("rawComputedExpireTimestamp=",this.rawComputedExpireTimestamp);
      // 计算并显示剩余时间文本
      this.updateRemainingText(expireTime);
      // 3. 打开弹窗
      this.multiTransformDialogVisible = true;
    },
    // 监听 InputNumber 计数器改变
    handleUpperLimitChange(currentValue, oldValue) {
      console.log("oldValue=", oldValue);
      console.log("currentValue=", currentValue);
      console.log("this.rawComputedExpireTimestamp=",this.rawComputedExpireTimestamp);
      if (!this.rawComputedExpireTimestamp) return;
      const now = new Date().getTime();
      // 1. 获取当前还剩余的毫秒数 (基于上一次计算好的过期时间戳 - 当前时间戳)
      const currentRemainingMs = this.rawComputedExpireTimestamp - now;
      console.log("currentRemainingMs=",currentRemainingMs);
      if (currentRemainingMs <= 0){
        this.$notify.error({title: '错误', message:"过期卡密不能转换"});
        return;
      } 
      // 2. 核心转换公式：新的剩余毫秒数 = 当前的剩余毫秒数 * 旧的多开上限 / 新的多开上限
      const newRemainingMs = (currentRemainingMs * oldValue) / currentValue;
      // 3. 计算出新的过期时间戳 = 当前时间 + 新的剩余毫秒数
      const newExpireTime = now + newRemainingMs;
      // 4. 缓存提交需要的时间戳
      this.rawComputedExpireTimestamp = Math.floor(newExpireTime);
      console.log("监听 InputNumber rawComputedExpireTimestamp=", this.rawComputedExpireTimestamp);
      // 5. 格式化给前端展示
      this.computedExpireDate = this.timestampToTime(this.rawComputedExpireTimestamp);
      console.log("监听 InputNumber computedExpireDate=", this.computedExpireDate);
      // 6. 更新剩余时间文本（包含小时）
      this.updateRemainingText(this.rawComputedExpireTimestamp);
    },
    // 辅助函数：根据目标时间戳计算剩余的“天数和小时数”或“总小时数”
    updateRemainingText(expireTimestamp) {
      const now = new Date().getTime();
      const diffMs = expireTimestamp - now;
      if (diffMs <= 0) {
        this.computedRemainingText = "已过期 (0 小时)";
        return;
      }
      this.computedRemainingText =`剩余约:${Math.floor(diffMs / (1000 * 60 * 60))}小时`; // 总剩余小时数
    },
    async confirmTransform(){
      try {
        const params = {
          cardPassword: this.currentRow.cardPassword,
          upperLimit: this.form.upperLimit,
        };
        console.log("提交多开转换参数：", params);
        
        // 模拟调用后端 API
        const result = await this.$http.post('/multitransform', params);
        console.log("转换result=",result);
        console.log("result.data.meta.status=",result.data.meta.status);
        if(result.data.meta.status == 200){
          console.log("成功");
          this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
          console.log("1111");
          this.multiTransformDialogVisible = false;
          // 刷新表格数据
          this.getCardPassword(); 
        }else{
          console.log("失败");
          this.$notify.error({title: '多开转换失败',message:result.data.meta.msg});
        }
      } catch (error) {
        console.log("error=",error);
        this.$notify.error({title: '多开转换失败：',error});
      }
    },
    async showpopo(val){
      //console.log('显示时候触发',val);
      let result = window.localStorage.getItem(val)
      if(!result){
        this.state = true
        result = await this.$http.post('getIp',{ip:val})
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          return this.$notify.error({title: '获取失败',message:result.data.meta.msg});
        }
        result = result.data.data
        window.localStorage.setItem(val, JSON.stringify(result))
      }
      this.ip = result
    },
    close(){
      this.ip = ""
    },
    
    onlineHandleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.onlineQueryInfo.pagesize = val
      this.cardPasswordLog()
    },
    // 监听 页码值 改变的事件
    onlineHandleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.onlineQueryInfo.pagenum = val
      this.cardPasswordLog()
    },
    //导入卡密
    imports(){
      this.importDialog = true
      this.file = {};
      if(this.$refs.upload){
        this.$refs.upload.clearFiles();
      }
    },
    // 上传文件，获取文件流
    handleChange(file) {
      //每次上传前都清空
      this.file = {};
      //赋值
      this.file.file = file.raw;
    },
    
    async importCsv() {
      if(Object.keys(this.file).length != 0){
        let testmsg = this.file.file.name.substring(this.file.file.name.lastIndexOf('.')+1)
        const extension = testmsg === 'csv'
        //console.log('this.file.size====',this.file.file.size);
        const isLt2M = this.file.file.size / 1024 > 200
        if(!extension) {
          this.$message({
            message: '上传文件只能是 csv格式!',
            type: 'warning'
          });
          return
        }
        if(isLt2M) {
          this.$message({
            message: '上传文件大小不能超过 200kb!',
            type: 'warning'
          });
          return
        }
        let param = new FormData(); //创建form对象
        param.append('file', this.file.file);
        param.append('email', this.$store.state.account);
        //console.log(param.get('file')); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
        let config = {
          headers:{'Content-Type':'multipart/form-data'}
        }; //添加请求头
        const result = await this.$http.post("upload", param, config);
        console.log('result',result);
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误', message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功', message: result.data.meta.msg, type: 'success'});
        this.getCardPassword()
        this.importDialog = false
      }else{
        //this.$message.error('上传文件不能为空');
        this.$notify.error({title: '错误',message:'上传文件不能为空'});
      }
    },
    async module(){
      const result = await this.$http.get(`moduledownload/?email=${this.$store.state.account}`,{
        responseType: 'blob',
      });
      let url = window.URL.createObjectURL(new Blob([result.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.$store.state.account+".csv");
      document.body.appendChild(link);
      console.log('result',result);
      link.click();
      console.log('result',result);
    },
    changeInput(e){
      this.$forceUpdate()
    },
    multiMerge(){
      this.multiMergeDialogVisible = true
    },
    confirmMerge() {
      // 1. 优先校验主卡
      this.$refs.mergeFormRef.validate(async (valid) => {
        if (valid) {
          try {
            // 校验通过后的合并逻辑...
            console.log('校验通过，可以提交合并数据');
            console.log('主卡卡密:', this.mergeForm.mainCard);
            console.log('副卡列表:', this.mergeForm.subCardList);
            const params = {
              mainCard: this.mergeForm.mainCard,
              subCardList: this.mergeForm.subCardList,
            };
            console.log("提交多开转换参数：", params);
            
            // 模拟调用后端 API
            const result = await this.$http.post('/multimerge', params);
            console.log("合并result=",result);
            if(result.data.meta.status == 200){
              console.log("成功");
              this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
              console.log("1111");
              this.multiTransformDialogVisible = false;
              // 刷新表格数据
              this.getCardPassword(); 
              this.multiMergeDialogVisible = false;
            }else{
              console.log("失败");
              this.$notify.error({title: '多开合并失败：',message:result.data.meta.msg});
            }
          }catch (error) {
            console.log("error=",error);
            this.$notify.error({title: '多开合并失败：',error});
          }
        } else {
          return false;
        }
      });
    },
    
    // 弹窗关闭时重置表单和提示
    resetForm() {
      if (this.$refs.mergeFormRef) {
        this.$refs.mergeFormRef.resetFields();
      }
    }
  },
  filters:{
    capitalize(value){
      if(Array.isArray(value)){
        value = value.toString()
        value = value.replace('[','')
        value = value.replace(']','')
      }
      return value
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-button{
    margin: 2px 10px;
  }
  .operation{
    margin-left: 10px;
    margin-right: 0px;
  }
  .navbtn{
    margin-bottom: 20px;
  }
  
  .el-dropdown{
    margin-left: 10px;
    color: #409EFF;
  }
  .el-table{
    .el-button{
      margin-left: 10px;
    }
    td{
      padding: 0 !important;
      height: 30px;
      line-height: 30px;
    }
  }
  
  
}
.el-badge{
  margin-right: 30px;
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-top: 6px;
  }
}




.el-tooltip{
  float: left;
  margin-left: 25px;
}
.itemlist{
  margin-left: 0px;
}
.batch{
  display: flex;
  // justify-content:space-around;
  justify-content: space-between;
  flex-flow: row wrap;
  align-content: flex-start;
  .el-button {
    // box-sizing: border-box;
    // flex: 0 0 20%;
    margin-bottom: 5px;
  }
}

.datetime{
  margin-left: -58px;
}

.islabel{
  padding-right: 13px;
  margin-left: -11px;
}
.edit-custom{
  margin-left: -44px;
}

.edit-form{
  margin-left: 20px;
}

.crowding{
  margin-left: -45px;
}
.single{
  margin-left: -58px;
}
.singlecreate{
  margin-left: -38px;
}
.deviceid{
  margin-left: -20px;
}
.newcreatecardpassword{
  .el-form-item{
    padding: 0 35px 0 0;
  }
}
.edit{
  .el-form-item{
    padding: 0 35px 0 0;
  }
  .unbindnum{
    margin-left: -20px;
  }
}

.frezee{
  margin-left: 0px !important;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin-right: 10px;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  //margin: 0 auto;
  //display: block;
}
.card-log{
  // margin: 0 10px;
  margin-bottom: 20px;
  .el-card{
    border-radius: 7px;
  }
  .el-card__body{
    padding: 10px !important;
  }
}
.el-table{
  .text-record{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
}



.popover-scroll-container {
    /* 设置最大高度，超过此高度将出现滚动条 */
    max-height: 70vh; 
    /* 纵向滚动 */
    overflow-y: auto;
    /* 优化滚动条在移动端或现代浏览器下的体验 */
    overflow-x: hidden;
    padding-right: 5px;
    -webkit-overflow-scrolling: touch;
}

/* 可选：美化滚动条（针对 Webkit 浏览器） */
.popover-scroll-container::-webkit-scrollbar {
    width: 6px;
}
.popover-scroll-container::-webkit-scrollbar-thumb {
    background: #e5e5e5;
    border-radius: 10px;
}
.popover-scroll-container::-webkit-scrollbar-track {
    background: transparent;
}


.token{
  color: #2f54eb;
  background: #f0f5ff;
  border-color: #adc6ff;
}
.cardrefresh{
  margin-right: 10px;
}

.el-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.card-header-flex {
  display: flex;
  align-items: center;
  /* 关键：让子元素分别靠左和靠右 */
  justify-content: space-between; 
  white-space: nowrap;
  /* 移动端如果太窄依然允许滚动 */
  // overflow-x: auto;
}

/* 左侧按钮容器，内部也要 Flex 布局来保持间距 */
.left-actions {
  display: flex;
  align-items: center;
  gap: 10px; /* 按钮之间的间距 */
}

.date-select {
  width: 150px !important;
  /* 电脑端时，如果不想它贴得太死，可以加个微调 */
  margin-left: 20px; 
}

/* 隐藏滚动条 */
.card-header-flex::-webkit-scrollbar {
  display: none;
}

/* 清新蓝绿/薄荷青风格 */
.merge-btn {
  color: #fff;
  background-color: #009688; /* 沉稳的青绿色/墨绿色调 */
  border-color: #009688;
}
.merge-btn:hover, .merge-btn:focus {
  background-color: #26a69a;
  border-color: #26a69a;
}

/* 建议的配套样式 */
.section-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #303133;
}
.sub-card-section {
  margin-top: 15px;
}

.tip-title-danger {
  color: #f56c6c; /* Element UI 危险/警告红色 */
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 12px;
}

@media screen and (max-width:479px) {
  .el-form-item{
    .lf{
      margin: 0;
    }
    .lr{
      margin-left: 6px !important;
    }
  }
}
</style>